import apiClient from '@/services/InvoiceapiClient'
export default {
    //<!-----------------------------quotation page api's-------------------------------->
    getSales(page, count, search, status, sort, label, from_date, to_date, custom, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/quotation/' + page + '/' + count + '?search=' + search + '&status=' + status + '&from_date=' + from_date + '&to_date=' + to_date + '&sort=' + sort + '&label=' + label + '&custom=' + custom)
    },
    getSalesExport(page, count, search, status, sort, label, from_date, to_date, custom, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/quotation/export/' + page + '/' + count + '?search=' + search + '&status=' + status + '&from_date=' + from_date + '&to_date=' + to_date + '&sort=' + sort + '&label=' + label + '&custom=' + custom)
    },
    postChangeStatus(ids, convertmodule, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        var module = 'converttoorder';
        if (convertmodule == 'invoice') {
            module = 'ChangeStatus'
        }
        return apiClient.post('/quotation/' + module, ids)
    },
    getSalesDetails(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/quotation/QuotationDetails', data)
    },
    postSales(form, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/quotation/create', form)
    },
    postSalesUpdate(form, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/quotation/update/' + id, form)
    },
    getSale(id, page,type, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        var url = 'view/' + id+'?type='+type;
        return apiClient.get('/quotation/' + url)
    },
    getSaleView(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/quotation/viewpage/' + id)
    },

    postFiltercreateSales(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/quotation/filtercreate', data)
    },
    /**
     * bulk delete api 
     */
    postSalestBulkDelete(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/quotation/bulkdelete', data)
    },
    /**
     * 
     * @param {*} data 
     * @param {*} id 
     */
    postFilterudpateSales(data, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/quotation/filterupdate/' + id, data)
    },
    /**
     * 
     * @param {*} data 
     */
    postFilterdeleteSales(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/quotation/filterdelete', data)
    },
    /**
     * 
     * @param {*} id 
     * @param {*} form 
     */
    getSalesDelete(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/quotation/singledelete', data)
    },
    /**
     * Change Status
     * @param {*} id 
     * @param {*} form 
     */
    getQuotationApprove(ids, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/quotation/statusapproval', ids)
    },
    /**
     *  Bulk Delete
     * @param {*} id 
     * @param {*} form 
     */
    postSalesOrderBulkDelete(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/sales-order/bulkdelete', data)
    },
    /**
     *  Draft Status
     * @param {*} id 
     * @param {*} form 
     */
    getSalesDraft(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/quotation/converttodraft', data)
    },
    getQuotationConvertToInvoice(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/quotation/converttoinvoice/' + data)
    },
    changeAcceptDecline(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/quotation/acceptstatus', data)
    },
    quotSettingsUpdate(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/quotation/enableedit', data)
    },
}